<style lang="scss">
.notify {
  position: fixed;
  bottom: 0;
  left: calc(50% - 75px);
  z-index: 10;
  display: block;
  width: 150px;
  height: 150px;
  margin: 10% auto;
  border-radius: 50%;
  stroke-width: 5px;
  stroke: #fff;
  stroke-miterlimit: 10;

  &.--success {
    box-shadow: inset 0 0 0 #00c851;
    animation: fillsuccess 0.4s ease-in-out 0.4s forwards,
      scale 0.3s ease-in-out 0.9s both;
  }

  &.--error {
    box-shadow: inset 0 0 0 #ff4444;
    animation: fillerror 0.4s ease-in-out 0.4s forwards,
      scale 0.3s ease-in-out 0.9s both;
  }
}

.notify__type {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.9s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fillsuccess {
  100% {
    box-shadow: inset 0 0 0 calc(150px / 2) #00c851;
  }
}

@keyframes fillerror {
  100% {
    box-shadow: inset 0 0 0 calc(150px / 2) #ff4444;
  }
}
</style>

<template>
  <v-slide-y-transition>
    <svg
      v-show="self"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      :class="['notify', `--${type}`]"
    >
      <path class="notify__type" fill="none" stroke-linecap="round" :d="pathD" />
    </svg>
  </v-slide-y-transition>
</template>

<script>
const SUCCESS = 'success'
const SUCCESS_D = 'M14.1 27.2l7.1 7.2 16.7-16.8'

const ERRRO = 'error'
const ERRRO_D = 'M16 16 36 36 M36 16 16 36'

export default {
  name: 'Notify',
  data() {
    return {
      self: false,
      type: ERRRO,
      pathD: ERRRO_D,
      timer: 0,
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    show(type) {
      clearTimeout(this.timer)

      this.self = true
      this.type = type
      this.pathD = type === SUCCESS ? SUCCESS_D : ERRRO_D

      if (this.self) {
        this.timer = setTimeout(() => {
          this.self = false
        }, 2000)
      }
    },
  },
}
</script>
